import { useNavigate } from "react-router-dom";
import { PatternCreateForm } from "../../ui-components";
import { Flex, Heading, Link } from "@aws-amplify/ui-react";
import { Helmet } from "react-helmet";
import React from "react";

import { generateClient } from "aws-amplify/api";
import { PatternCreateFormInputValues } from "../../ui-components/PatternCreateForm";
import { Schema } from "../../../amplify/data/resource";
import { FaArrowLeft } from "react-icons/fa6";
import { I18n } from "aws-amplify/utils";

const client = generateClient<Schema>();

type DanceStyle = Schema["DanceStyle"]["type"];
type Pattern = Schema["Pattern"]["type"];

export default function PatternCreate() {
  const [danceStyles, setDanceStyles] = React.useState<DanceStyle[]>([]);

  React.useEffect(() => {
    const danceStylesSub = client.models.DanceStyle.observeQuery().subscribe({
      next: ({ items }) => {
        setDanceStyles(items);
      },
    });
    return () => {
      danceStylesSub.unsubscribe();
    };
  }, []);

  const navigate = useNavigate();
  const handleSuccess = (
    _fields: PatternCreateFormInputValues,
    pattern: Pattern
  ) => {
    navigate(`/patterns/${pattern.id}/view`);
  };

  return (
    <Flex gap="1rem" direction="column">
      <Helmet>
        <title>{I18n.get("Create Pattern")}</title>
      </Helmet>
      <Flex marginTop={"1rem"}>
        <Heading level={1}>{I18n.get("Create Pattern")}</Heading>
      </Flex>
      <Flex>
        <Link onClick={() => navigate(-1)}>
          <FaArrowLeft aria-label={I18n.get("Back")} />
        </Link>
      </Flex>
      <Flex>
        <PatternCreateForm
          danceStyles={danceStyles}
          onSuccess={handleSuccess}
        />
      </Flex>
    </Flex>
  );
}
